import { ButtonHTMLAttributes, MouseEvent, useState } from 'react';
import { MdOutlineContentCopy } from 'react-icons/md';
import { copyToClipboard } from 'helpers';
import { FADE_TIME } from 'commons';
import * as S from './styles';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  content: string;
}

export function CopyButton({ content, ...rest }: Props) {
  const [showMessage, setShowMessage] = useState(false);
  const [fadeMessage, setFadeMessage] = useState(false);

  function handleCopy(event: MouseEvent<HTMLButtonElement>) {
    event.stopPropagation();

    copyToClipboard(content);

    if (showMessage) return;

    setShowMessage(true);
    setFadeMessage(false);

    setTimeout(() => {
      setFadeMessage(true);

      setTimeout(() => {
        setShowMessage(false);
      }, FADE_TIME);
    }, 1500);
  }

  return (
    <S.Wrapper>
      {showMessage && <S.PopUp $fade={fadeMessage}>copiado</S.PopUp>}

      <S.Button onClick={handleCopy} type="button" {...rest}>
        <MdOutlineContentCopy />
      </S.Button>
    </S.Wrapper>
  );
}
